import { HttpClient } from "@angular/common/http";
import {
    AfterViewInit,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from "@angular/core";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { helper } from "src/environments/helper";

@Component({
    selector: 'app-acord-comercializare',
    templateUrl: './acord-comercializare.component.html',
    styleUrls: ['./acord-comercializare.component.scss']
})
export class AcordComercializareComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
    @Input() type_slug!: string;
    @Input() dataTableParams!: any;
    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;
    isLoading = false;
    // dateBorderou: Date = new Date();
    // formattedDate: string = formatDate(this.dateBorderou, 'yyyy-MM-dd', 'en-US');
    // type: number = ?;
    // current_info: any = null;
    dtLink =
        environment.interop.basePath +
        environment.interop.autorizatiiComerciale.nomenclatoare.borderou
            .borderouList;

    constructor(private http: HttpClient) { }

    ngAfterViewInit(): void {
        this.dtTrigger.next("");
    }
    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }
    ngOnInit(): void {
        this.renderDT();
        // this.getInfo();
    }

    renderDT() {
        this.isLoading = true;

        this.dtOptions = {
            responsive: true,
            serverSide: true,
            searching: false,
            pageLength: 25,
            order: [[0, "desc"]],
            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.type_slug = this.type_slug;
                dataTablesParameters.date = this.dataTableParams.formattedDate;

                this.http
                    .post<any>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: "Nr crt",
                    data: "id",
                    sortable: false,
                },
                {
                    title: "Nr/Data Cerere",
                    data: null,
                    sortable: false,
                    render: (data: any, type: any, row: any) => {
                        return `
                            <div style="display: flex; align-items: center; gap: 5px; width:200px" >
                                <span>${row.cerere_numar ? row.cerere_numar : "N/A"}</span>
                                <span>/</span>
                                <span style="padding: 2px 4px; background-color: #bdbdbd; border: 0px;border-radius:10px">${row.cerere_data}</span>
                            </div>
                        `;
                    },
                },
                {
                    title: "Denumire Societate",
                    data: "f_nume",
                    sortable: false,
                },
                {
                    title: "Adresa Punct lucru",
                    data: "punct_lucru",
                    sortable: false,
                },
                {
                    title: "CAEN",
                    data: "f_activitati_caen",
                    sortable: false,
                },
                {
                    title: "Denumire Administrator",
                    data: "nume_administrator",
                    sortable: false,
                },
            ],
        };
    }

    rerenderDT(paginate = false): void {
        this.isLoading = true;
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            this.isLoading = false;
            dtInstance.draw(paginate);
        });
    }

    // reset() {
    //     this.rerenderDT();
    //     this.getInfo();
    // }

    // onDateChange(event: any) {
    //     this.formattedDate = formatDate(event.value, 'yyyy-MM-dd', 'en-US');
    //     this.rerenderDT();
    //     this.getInfo();
    // }

    // openAddDialog() {
    //     const dialogRef = this.dialog.open(AddBorderouComponent, {
    //         ...this.dialogService.getDialogConfig(),
    //         data: {
    //             type_slug: this.type_slug,
    //             date: this.formattedDate
    //         },
    //     });
    //     dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
    //         if (success) {
    //             Swal.fire({
    //                 title: helper.dialogConfig.headers.success,
    //                 text: "Borderou adăugat cu succes!",
    //                 icon: "success",
    //                 confirmButtonText: helper.dialogConfig.buttonLabels.close,
    //                 allowOutsideClick: false,
    //             });
    //         }
    //     });
    // }

    // print() {
    //     this.isLoading = true;
    //     const data = { date: this.formattedDate };
    //     this.borderouService.print(data, this.type_slug).subscribe(
    //         (response) => {
    //             // Assuming the file is a PDF. If not, replace 'application/pdf' with the correct mime type.
    //             this.isLoading = false;
    //             const blob = new Blob([response], { type: "application/pdf" });
    //             const filename = `print_${this.type_slug}_${this.formattedDate}.pdf`;
    //             saveAs(blob, filename);
    //         },
    //         (error) => {
    //             // Handle error
    //             this.isLoading = false;
    //             console.error("Error downloading the file", error);
    //         }
    //     );
    // }

    // getInfo() {
    //     this.borderouService.infoBorderou(this.type_slug, this.formattedDate).subscribe(response => {
    //         this.current_info = response;
    //     })
    // }

    // downloadBorderouInfo(id: number) {
    //     const urlDownload = this.borderouService.downloadBorderouFileURL + id;

    //     this.appFilesService.downloadFile(urlDownload);
    // }
}
